import { logger } from './lib/monitoring/logger'

const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry)
      onINP(onPerfEntry)
      onFCP(onPerfEntry)
      onLCP(onPerfEntry)
      onTTFB(onPerfEntry)
    })
  } else {
    // Default: Send Web Vitals to Sentry
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      const sendToSentry = (metric: any) => {
        logger.logPerformance({
          name: `web-vital-${metric.name}`,
          duration: metric.value,
          timestamp: Date.now(),
          metadata: {
            id: metric.id,
            rating: metric.rating,
            navigationType: metric.navigationType,
          },
        })
      }

      onCLS(sendToSentry)
      onINP(sendToSentry)
      onFCP(sendToSentry)
      onLCP(sendToSentry)
      onTTFB(sendToSentry)
    })
  }
}

export default reportWebVitals
